// extracted by mini-css-extract-plugin
export default {"submitButton":"IgXqkU1BYWrHveqmZezA"};